import { Typography } from '@mui/material';
import { Box, styled } from '@mui/system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { filterFilters } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/GVT/PayConstants/components/FreeHypothesis/helpers/dataHelpers';

type Props = {
    cadreEmploi: string;
    category: string;
    filiere: string;
    job: string[];
};
const InformationDisplay = styled(Typography)(({ theme }) => ({
    width: 'fit-content',
    padding: '0.5rem 1rem',
    borderRadius: '0.5rem',
    span: {
        paddingLeft: '10px',
        color: theme.palette.primary.main,
    },
}));
const HypothesisResume = ({
    category,
    filiere,
    cadreEmploi,
    job,
}: Props): React.ReactElement => {
    const { t } = useTranslation();
    const filteredFilters = filterFilters({
        category,
        filiere,
        cadreEmploi,
        jobLabel: job,
    });
    return (
        <>
            <Box sx={{ display: 'inline-flex' }}>
                {filteredFilters.category && (
                    <InformationDisplay>
                        {t(
                            'humanResources.simulation.freeHypothesis.ifse.category',
                        )}
                        <span>{category.toUpperCase()}</span>
                    </InformationDisplay>
                )}
                {filteredFilters.filiere && (
                    <InformationDisplay>
                        {t(
                            'humanResources.simulation.freeHypothesis.ifse.filiere',
                        )}
                        <span>{filiere}</span>
                    </InformationDisplay>
                )}
            </Box>
            <Box sx={{ display: 'inline-flex' }}>
                {filteredFilters.cadreEmploi && (
                    <InformationDisplay>
                        {t(
                            'humanResources.simulation.freeHypothesis.ifse.cadreEmploi',
                        )}
                        <span>{cadreEmploi}</span>
                    </InformationDisplay>
                )}
                {filteredFilters.jobLabel && (
                    <InformationDisplay>
                        {t('humanResources.simulation.freeHypothesis.ifse.job')}

                        <span>{job.map((item) => `${item},`).join(' ')}</span>
                    </InformationDisplay>
                )}
            </Box>
        </>
    );
};

export default HypothesisResume;
